import React from "react";

export default function BackToTop({ scroll }) {
  const handleClick = () => {
    document.querySelector('html').scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {scroll && (
        <button
          type="button"
          onClick={handleClick}
          aria-label="Naar boven"
          className="scroll-to-target scroll-to-top"
        >
          <span className="scroll-to-top__wrapper">
            <span className="scroll-to-top__inner"></span>
          </span>
          <span className="scroll-to-top__text">Naar boven</span>
        </button>
      )}
    </>
  );
}
